export default __webpack_public_path__ + "static/media/avatar-7.b69ef26b.jpg";